import {useRpcQuery} from '@tnc/shared';

import {dateFormatter} from '@/lib/helpers';

import {useAuth} from '@/providers/components/authProvider';

type TimelineItem = {
  type: 'position' | 'exchange_transfer' | 'transaction';
  date: string;
  position_id?: number;
  order_type?: string;
  transaction?: {
    transaction_id: number;
    amount: number;
    date: string;
  };
  transfer_id?: number;
  from_position?: {
    position_id: number;
    order_type: string;
  };
  to_position?: {
    position_id: number;
    order_type: string;
  };
  direction?: 'incoming' | 'outgoing';
  quantity?: number;
  transaction_id?: number;
  transaction_type?: 'deposit' | 'withdraw';
  amount?: number;
  account_from?: string;
  account_to?: string;
};

const RecentActivity = () => {
  const {
    userAccounts: {speculator},
  } = useAuth();

  const {data: timeline} = useRpcQuery({
    functionName: 'get_speculator_profile_activity_timeline',
    enabled: !!speculator,
  });

  const getIcon = (type: string) => {
    switch (type) {
      case 'position':
        return <i className="fa fa-shopping-cart text-blue-500 h-4 w-4" />;
      case 'exchange_transfer':
        return <i className="fa fa-exchange-alt text-green-500 h-4 w-4" />;
      case 'transaction':
        return <i className="fa fa-money-bill-wave text-yellow-500 h-4 w-4" />;
      default:
        return null;
    }
  };

  const getActivityText = (item: TimelineItem) => {
    switch (item.type) {
      case 'position':
        return {
          title: `New ${item.order_type} Position`,
          description: `Position #${item.position_id} created`,
        };
      case 'exchange_transfer':
        return {
          title: 'Exchange Transfer',
          description: `${item.direction === 'incoming' ? 'Received from' : 'Sent to'} Position #${
            item.direction === 'incoming' ? item.from_position?.position_id : item.to_position?.position_id
          }`,
        };
      case 'transaction':
        return {
          title: `${item.transaction_type?.charAt(0).toUpperCase()}${item.transaction_type?.slice(1)}`,
          description: `$${item.amount?.toLocaleString()}`,
        };
      default:
        return {title: '', description: ''};
    }
  };

  return (
    <div className="box h-full">
      <div className="box-header">
        <h5 className="box-title">Recent Activity</h5>
      </div>
      <div className="box-body grow">
        <div className="latest-timeline grow overflow-y-auto">
          <ul className="timeline-main list-none">
            {(timeline?.data as TimelineItem[])?.map((item: TimelineItem, index: number) => {
              const {title, description} = getActivityText(item);
              return (
                <li key={index} className="activity">
                  <div className="featured_icon1">{getIcon(item.type)}</div>
                  <div className="mb-4 flex justify-between">
                    <div>
                      <span className="font-semibold">{title}</span>
                      <p className="mb-0 text-[0.813rem] text-[#8c9097] dark:text-white/50">{description}</p>
                    </div>
                    <div>
                      <span className="text-[0.813rem] text-[#8c9097] dark:text-white/50">
                        {dateFormatter(item.date)}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
